import { Outlet } from "react-router-dom";
import { useZymedOpenedEvent, ZYMED_EVENTS } from "../../utils/zymedAnalytics";

const Tatvapedia = () => {
  useZymedOpenedEvent(ZYMED_EVENTS.PEDIA_OPENED);
  return (
    <div>
      <Outlet /> {/* This is where nested routes will be rendered */}
    </div>
  );
};

export default Tatvapedia;
